import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SuperuserDashboard from "../../Pages/Dashboards/SuperuserDashboard";
import BranchDetails from "../../Pages/Dashboards/BranchDetails";
import PageNotFound from "../../Pages/PageNotFound";
import Profile from "../../Pages/users/Profile";

function SuperUser() {
  return (
    <Router>
      <Routes>
        <Route element={<SuperuserDashboard />} path="/" />
        <Route element={<Profile />} path="user-profile" />
        <Route element={<BranchDetails />} path="/branch-details/:branchId" />
        <Route element={<PageNotFound />} path="*" />
      </Routes>
    </Router>
  );
}

export default SuperUser;
